import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { apiClient } from '../../lib/api';
import { useAuth } from '../../lib/auth';

const CLOSED = ['closed_by_client', 'auto_closed', 'closed_not_relevant', 'closed_blocked'];

export function ReturningBanner() {
  const { isAuthenticated, user } = useAuth();
  const conversations = useQuery({
    queryKey: ['home', 'conversations'],
    queryFn: () => apiClient.chat.listConversations({ page: 1 }),
    enabled: isAuthenticated,
  });

  if (!isAuthenticated) return null;

  const list = conversations.data?.data ?? [];
  const open = list.filter((item) => !CLOSED.includes(item.status));
  const active = open[0];

  if (active) {
    return (
      <section className="px-4 pt-4 md:px-8 xl:px-20">
        <div className="mx-auto flex max-w-[1280px] flex-wrap items-center gap-3 rounded-2xl border border-white/80 bg-white/55 px-4 py-3 shadow-[0_10px_30px_rgba(10,28,64,0.05)] backdrop-blur-xl md:px-5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white text-accent">
            ⚖
          </span>
          <div className="min-w-0 flex-1">
            <div className="text-[14px] font-semibold text-ink">
              {active.lawyerId ? 'Продолжить обращение' : 'Подбираем юриста'}
            </div>
            <div className="truncate text-[12.5px] text-muted">
              {active.subject ?? 'Ваш вопрос'} ·{' '}
              {active.lawyer?.name ?? 'юрист ещё не назначен'}
            </div>
          </div>
          <Link
            to="/chat"
            className="rounded-xl bg-ink-gradient px-4 py-2 text-[13px] font-semibold text-white"
          >
            Открыть чат
          </Link>
        </div>
      </section>
    );
  }

  if (list.length > 0) {
    return (
      <section className="px-4 pt-4 md:px-8 xl:px-20">
        <div className="mx-auto flex max-w-[1280px] flex-wrap items-center gap-3 rounded-2xl border border-white/80 bg-white/55 px-4 py-3 shadow-[0_10px_30px_rgba(10,28,64,0.05)] backdrop-blur-xl md:px-5">
          <div className="min-w-0 flex-1">
            <div className="text-[14px] font-semibold text-ink">
              {user?.name ? `${user.name}, все обращения закрыты` : 'Все обращения закрыты'}
            </div>
            <div className="text-[12.5px] text-muted">
              История сохранена в кабинете. Можно задать новый вопрос.
            </div>
          </div>
          <Link
            to="/chat"
            className="rounded-xl border border-line bg-white px-4 py-2 text-[13px] font-semibold text-ink"
          >
            Новый вопрос
          </Link>
          <Link
            to="/cases"
            className="rounded-xl border border-line bg-white px-4 py-2 text-[13px] font-semibold text-ink"
          >
            Мои дела
          </Link>
        </div>
      </section>
    );
  }

  return null;
}
